export const BIKENUMFLAG = "BIKENUMFLAG";
export const ADDBIKENUMBER = "ADDBIKENUMBER";
export const ADDBIKEDETAILS = "ADDBIKEDETAILS";
export const ALLBIKEDETAILS = "ALLBIKEDETAILS";
export const BIKE_INS_PRODUCT = "CAR_INS_PRODUCT";
export const BIKE_PREV_INS_LIST = "PREV_INS_LIST";
export const BIKEQUICKQUOTES = "BIKEQUICKQUOTES";
export const CUSTOMER_DETAILS = "CUSTOMER_DETAILS";
export const ADD_VAHAN_DATA = "ADD_VAHAN_DATA";
export const CREATE_PROPOSAL = "CREATE_PROPOSAL";
export const PAYMENT_REQUEST = "PAYMENT_REQUEST";
export const QUICKQUOTE_POST = "QUICKQUOTE_POST";
export const QUICKQUOE_VALUE = "QUICKQUOE_VALUE";
export const SET_IDV = "SET_IDV";
export const KYC_STATUS = "KYC_STATUS";
export const POLICY_PDF = "POLICY_PDF";
export const RESET_BIKE = "RESET_BIKE";
export const POSP_DATA = "POSP_DATA";
export const POSP_BIKENUM = "POSP_BIKENUM";
export const LOGOUT_POSP = "LOGOUT_POSP";
export const Posp_DETAILS = "Posp_DETAILS";
export const Posp_SINGLE_QUOTE = "Posp_SINGLE_QUOTE";
export const QUOTE_LIST = "QUOTE_LIST";
export const PREV_POLICY_DETAIL = "PREV_POLICY_DETAIL";
export const SAVE_PASS = "SAVE_PASS";
export const SELECTED_QUOTE = "SELECTED_QUOTE";
export const COMPARE_QQ = "COMPARE_QQ";
export const SHORTLIST_QQ = "SHORTLIST_QQ";
export const ERROR_QUOTES = "ERROR_QUOTES";
export const SELECTED_ADDONS = "SELECTED_ADDONS";
export const TRANS_ID = "TRANS_ID";
export const ROUTE = "ROUTE";
export const UAT_LOGIN = "UAT_LOGIN";
export const RESET_UAT = "RESET_UAT";
export const RESET_COMMON = "RESET_COMMON";
export const ONBOARD_OTP_DATA = "ONBOARD_OTP_DATA";
export const LOGIN_OBOARD = "LOGIN_OBOARD";
export const ONBOARD_DETAILS = "ONBOARD_DETAILS";
export const ONBOARD_DOC_DETAILS = "ONBOARD_DOC_DETAILS";
export const LOG_STATE = "LOG_STATE";
export const SELECTED_LIFE_PLAN = "SELECTED_LIFE_PLAN";
export const TOKEN_EXPIRED = "TOKEN_EXPIRED";
export const PAY_TILL_AGE = "PAY_TILL_AGE";
export const PAY_TILL_UPDATE = "PAY_TILL_UPDATE";
export const SEND_REQUEST = "SEND_REQUEST";
export const OTP_SENT = "OTP_SENT";
export const ADD_PRODUCT_TYPE = "ADD_PRODUCT_TYPE";
